import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Form, Radio } from 'grab-ui';

import css from './radio-button.less';

const cx = classnames.bind(css);
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const RadioOption = Radio.Button;

const RadioButton = ({
  id,
  placeholder,
  options,
  className,
  optionClassName,
  disabled,
  fieldClassName,
  fieldOptions,
  form,
  onChange,
}) => {
  const { getFieldDecorator } = form;

  return (
    <FormItem className={cx('formItem', fieldClassName)}>
      {getFieldDecorator(id, fieldOptions)(
        <RadioGroup
          placeholder={placeholder}
          className={cx('radioGroup', className)}
          disabled={disabled}
          onChange={onChange}
        >
          {options.map(option => (
            <RadioOption
              className={cx('radioOption', optionClassName)}
              key={option.value}
              value={option.value}
              disabled={option.disabled}
            >
              {!!option.icon && (
                <img
                  className={css.iconOption}
                  src={option.icon}
                  alt={option.title}
                />
              )}
              {option.child}
            </RadioOption>
          ))}
        </RadioGroup>,
      )}
    </FormItem>
  );
};

RadioButton.propTypes = {
  id: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      title: PropTypes.string,
      child: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    }),
  ),
  className: PropTypes.string,
  optionClassName: PropTypes.string,
  disabled: PropTypes.bool,
  fieldClassName: PropTypes.string,
  fieldOptions: PropTypes.shape({}),
  form: PropTypes.shape({}).isRequired,
  onChange: PropTypes.func,
};

RadioButton.defaultProps = {
  placeholder: '',
  options: [],
  className: '',
  dropdownClassName: '',
  optionClassName: '',
  disabled: false,
  fieldClassName: '',
  fieldOptions: {},
  onChange: () => {},
};

export default RadioButton;
